import { gql } from "@apollo/client";

const TOUR_ACTIVITY_ITEM_FIELDS = `
  id
  activityCode
  providerCode
  name
  type
  destinationId
  destinationName
  countryCode
  hasContent
  carriedForward
  modalities {
    code
  }
`;

export const GET_TOUR_ACTIVITY_CATALOG_STATE = gql`
  query GetTourActivityCatalogState {
    tourActivityCatalogState {
      id
      indexName
      synchronizedAtUtc
      activityCount
      destinationCount
      failedDestinationCount
      carriedForwardCount
      providerCodes
    }
  }
`;

export const GET_TOUR_ACTIVITY_CATALOG_PAGE = gql`
  query GetTourActivityCatalog($destinationId: String!, $cursor: String, $pageSize: Int!) {
    tourActivityCatalog(destinationId: $destinationId, cursor: $cursor, pageSize: $pageSize) {
      pageSize
      hasMore
      nextCursor
      items {
        ${TOUR_ACTIVITY_ITEM_FIELDS}
      }
    }
  }
`;

export const GET_TOUR_ACTIVITY_CATALOG_DOCUMENT = gql`
  query GetTourActivityCatalogDocument($id: String!) {
    tourActivityCatalogDocument(id: $id) {
      ${TOUR_ACTIVITY_ITEM_FIELDS}
      normalizedName
      destinationCode
      countryName
      summary
      description
      highlights
      images {
        url
        sizeType
        order
      }
      modalities {
        code
        name
        onSale
        languages
        sessions
      }
      paxMin
      paxMax
      latitude
      longitude
      searchText
      synchronizedAtUtc
    }
  }
`;

export const GET_TOUR_ACTIVITY_CATALOG_SUGGESTIONS = gql`
  query GetTourActivityCatalogSuggestions($term: String!, $destinationId: String) {
    tourActivityCatalogSuggestions(term: $term, destinationId: $destinationId) {
      activityId
      name
      destinationId
      destinationName
      countryCode
      countryName
    }
  }
`;
